import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

function requireLogin (to, from, next) {
  if (store.state.auth.isLoggedIn) return next()

  next({
    name: 'login'
  })
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'all leases'
      },
      component: require('./views/Home').default,
      beforeEnter: requireLogin,
      children: [
        {
          path: '/websiteprofielen',
          name: 'websites',
          redirect: {
            name: 'all websites'
          },
          component: require('./views/Home/Websites').default,
          children: [
            {
              path: 'alle',
              name: 'all websites',
              component: require('./views/Home/Websites/All').default,
              meta: {
                title: 'Alle Websiteprofielen'
              }
            },
            {
              path: 'krediet',
              name: 'private lease websites',
              component: require('./views/Home/Websites/Private').default,
              meta: {
                title: 'Krediet Websiteprofielen'
              }
            },
            {
              path: 'financiallease',
              name: 'business lease websites',
              component: require('./views/Home/Websites/Business').default,
              meta: {
                title: 'Financial Lease Websiteprofielen'
              }
            }
          ]
        },
        {
          path: '/website/:websiteId',
          name: 'website details',
          component: require('./views/Home/WebsiteDetails').default,
          meta: {
            title: 'Websiteprofiel'
          },
          query: {
            tab: 0
          }
        },
        {
          path: '/berekenen',
          name: 'calculations',
          component: require('./views/Home/Calculations').default,
          meta: {
            title: 'Berekenen'
          },
          redirect: { name: 'calculations business lease' },
          children: [
            {
              path: 'financiallease',
              name: 'calculations business lease',
              component: require('./views/Home/Calculations/CalcBusinessLease').default
            },
            {
              path: 'krediet',
              name: 'calculations private lease',
              component: require('./views/Home/Calculations/CalcPrivateLease').default
            },
            {
              path: 'vkm',
              name: 'calculations vkm',
              component: require('./views/Home/Calculations/CalcVkm').default
            }
          ]
        },
        {
          path: '/notificaties',
          name: 'notifications',
          component: require('./views/Home/Notifications').default,
          meta: {
            title: 'Notificaties'
          }
        },
        {
          path: '/dealers',
          name: 'dealers',
          component: require('./views/Home/Dealers').default,
          meta: {
            title: 'Aangesloten Dealers'
          }
        },
        {
          path: '/tools',
          name: 'tools',
          component: require('./views/Home/Tools').default,
          meta: {
            title: 'Tools'
          }
        },
        {
          path: '/instellingen',
          name: 'settings',
          component: require('./views/Home/OrganizationSettings').default,
          redirect: { name: 'settings organization' },
          children: [
            {
              path: 'organisatie',
              name: 'settings organization',
              component: require('./views/Home/OrganizationSettings/TabOrganization').default,
              meta: {
                title: 'Organisatie instellingen'
              }
            },
            {
              path: 'meldingen',
              name: 'settings notifications',
              component: require('./views/Home/OrganizationSettings/TabPersonalisation').default,
              meta: {
                title: 'Meldingen'
              }
            },
            {
              path: 'facturen',
              name: 'settings invoices',
              component: require('./views/Home/OrganizationSettings/TabInvoices').default,
              meta: {
                title: 'Facturen'
              }
            },
            {
              path: 'gebruikers',
              name: 'settings users',
              component: require('./views/Home/OrganizationSettings/TabUsers').default,
              redirect: { name: 'settings users list' },
              children: [
                {
                  path: '',
                  name: 'settings users list',
                  component: require('./views/Home/OrganizationSettings/TabUsers/UserList').default,
                  meta: {
                    title: 'Gebruikersbeheer'
                  }
                },
                {
                  path: ':id',
                  name: 'settings users details',
                  component: require('./views/Home/OrganizationSettings/TabUsers/UserDetails').default,
                  meta: {
                    title: 'Gebruiker'
                  }
                }
              ]
            },
            {
              path: 'exporteren',
              name: 'settings exports',
              component: require('./views/Home/OrganizationSettings/TabExports').default,
              meta: {
                title: 'Exporteren'
              }
            }
          ]
        },
        // {
        //   path: '/kvk-kosten',
        //   name: 'kvk api costs',
        //   component: require('./views/Home/KvkApiCosts').default,
        //   meta: {
        //     title: 'KvK Kosten'
        //   }
        // },
        {
          path: '/leases',
          name: 'leases',
          redirect: {
            name: 'all leases'
          },
          component: require('./views/Home/Leases').default,
          children: [
            {
              path: 'alle',
              name: 'all leases',
              component: require('./views/Home/Leases/All').default,
              meta: {
                title: 'Alle Aanvragen'
              }
            },
            {
              path: 'financiallease',
              name: 'all business leases',
              component: require('./views/Home/Leases/Business').default,
              meta: {
                title: 'Financial Lease Aanvragen'
              }
            },
            {
              path: 'krediet',
              name: 'all private leases',
              component: require('./views/Home/Leases/Private').default,
              meta: {
                title: 'Krediet Aanvragen'
              }
            },
            {
              path: 'verzekering',
              name: 'all insurance leases',
              component: require('./views/Home/Leases/Insurances').default,
              meta: {
                title: 'Leases met verzekering'
              }
            }
          ]
        },
        {
          path: '/lease/:leaseId',
          name: 'lease details',
          component: require('./views/Home/LeaseDetails').default,
          meta: {
            title: 'Lease'
          }
        }
      ]
    },
    {
      path: '',
      component: require('./views/Auth').default,
      children: [
        {
          path: '/login',
          name: 'login',
          component: require('./views/Auth/Login').default,
          beforeEnter: (to, from, next) => {
            if (store.state.auth.isLoggedIn) return next({ name: 'home' })

            next()
          },
          meta: {
            title: 'Login'
          }
        },
        {
          path: '/verify',
          name: 'verify',
          query: {
            token: null
          },
          component: require('./views/Auth/Verify').default,
          meta: {
            title: 'Account activeren'
          },
          beforeEnter: (to, from, next) => {
            store.commit('auth/logout')

            next()
          }
        },
        {
          path: '/forgot',
          name: 'forgot',
          query: {
            token: null
          },
          component: require('./views/Auth/ForgotPassword').default,
          meta: {
            title: 'Nieuw wachtwoord'
          },
          beforeEnter: (to, from, next) => {
            store.commit('auth/logout')

            next()
          }
        }
      ]
    },
    {
      path: '/masquerade',
      name: 'masquerade',
      query: {
        token: null
      },
      beforeEnter: async (to, from, next) => {
        const token = to.query.token

        store.commit('auth/logout')

        if (!token) return next({ name: 'login' })

        await store.dispatch('auth/masquerade', {
          token
        })

        window.location = '/'
      }
    },
    {
      path: '*',
      name: '404',
      component: require('./views/NotFound').default
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.unsavedChanges) {
    const leave = window.confirm('Je hebt onopgeslagen wijzigingen. Weet je het zeker?')

    if (!leave) {
      return next(false)
    }

    // Throw away changes
    store.commit('setUnsavedChanges', false)
  }

  document.title = to.meta.title ? to.meta.title + ' - DFS Portal' : 'DFS Portal'

  next()
})

export default router
